import C3Chart from 'react-c3js';
import React from 'react';
import styles from './styles';
import TransformIcon from '@material-ui/icons/Transform';

const generateStageBarChart = (data, max, categories) => ({
  data: {
    columns: data,
    type: 'bar',
  },
  axis: {
    x: {
      type: 'category',
      categories,
    },
    y: {
      max,
      min: 0,
      padding: { top: 0, bottom: 0 },
    },
  },
  bar: {
    width: {
      ratio: 0.5, // this makes bar width 50% of length between ticks
    },
  },
});

// TODO consolidate
const renderNoData = () => {
  return (<div style={styles.noDataRow}>
    <TransformIcon style={styles.noData}/>
    <div>No tasks are available</div>
  </div>);
};

const StageProgressBarChart = ({ job, statistics }) => {
  if (!job || !job.profile || !job.profile.stages) {
    return renderNoData();
  }

  const data = [];
  const total = [];
  const categories = [];
  const counts = ['Completed'];
  job.profile.stages.forEach((stage) => {
    categories.push(stage.name);
    counts.push(statistics[stage.id] ? statistics[stage.id].complete : 0);
    total.push(statistics[stage.id] ? statistics[stage.id].total : 0);
  });
  const max = Math.max(...total);
  data.push(counts);
  const bars = generateStageBarChart(data, max, categories);
  console.log('bars', bars);
  return (<C3Chart data={bars.data} bar={bars.bar} axis={bars.axis}/>);
};

export default StageProgressBarChart;


// WEBPACK FOOTER //
// ./src/components/Reports/JobReport/StageProgressBarChart.js